import {useState} from 'react'
import {Stack} from 'react-bootstrap'
import {useCSVReader} from 'react-papaparse'
import upload from '../../../_metronic/images/FileUpload.svg'
type uploadCSV = {
  btnDisabled?: boolean
  setBtnDisabled?: any
  fileUploadErr: boolean
  setFileUploadErr: any
  setManualDisable?: any
  arrayHelpers: any
  setIsSubmit: any
  leaders: any
}
const UploadAgentCSV = ({
  btnDisabled,
  setBtnDisabled,
  fileUploadErr,
  setFileUploadErr,
  setManualDisable,
  arrayHelpers,
  setIsSubmit,
  leaders,
}: uploadCSV) => {
  const [csvValidationMsg, setCsvValidationMsg] = useState<string>('')
  const [validationMsg, setValidationMsg] = useState<string>('')
  const [uplodingMessage, setUplodingMessage] = useState(false)
  const {CSVReader} = useCSVReader()
  const validLeaderCodes = leaders.map((l: any) => l.leaderCode)
  return (
    <div className='upload-section'>
      <CSVReader
        maxFiles={1}
        accept='.csv'
        onUploadAccepted={async (results: any) => {
          // setFileUploadErr(true)
          let canUpload = true
          setValidationMsg('')
          setManualDisable && setManualDisable(true)

          // Check if CSV contains no data
          if (results.data.length === 0) {
            setBtnDisabled && setBtnDisabled(true)
            setValidationMsg('Please upload valid data')
            canUpload = false
          }

          // Ensure that the first row has the correct headers
          const columnName = Object.keys(results.data[0])
          if (
            columnName.length !== 5 ||
            columnName[0] !== 'Agent First Name' ||
            columnName[1] !== 'Agent Last Name' ||
            columnName[2] !== 'Agent Email ID' ||
            columnName[3] !== 'Agent Leader Code' ||
            columnName[4] !== 'Agent Rep Id'
          ) {
            canUpload = false
            setCsvValidationMsg('Headers are mismatched. Please upload a valid CSV format')
            setBtnDisabled && setBtnDisabled(true)
            return
          }

          // Check if mandatory fields are non-empty for each row
          results.data.forEach((agent: any, index: number) => {
            if (
              !agent['Agent First Name'] ||
              !agent['Agent Last Name'] ||
              !agent['Agent Email ID'] ||
              !agent['Agent Rep Id']
            ) {
              canUpload = false
              setBtnDisabled && setBtnDisabled(true)
              setCsvValidationMsg(`Row ${index + 1}: Please ensure all mandatory fields are filled`)
            }
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailPattern.test(agent['Agent Email ID'])) {
              canUpload = false
              setBtnDisabled && setBtnDisabled(true)
              setCsvValidationMsg(`Row ${index + 1}: Invalid email format`)
              return
            }
            if (
              agent['Agent Leader Code'] &&
              !validLeaderCodes.includes(agent['Agent Leader Code'])
            ) {
              canUpload = false
              setBtnDisabled && setBtnDisabled(true)
              setCsvValidationMsg(`Row ${index + 1}: Invalid Agent Leader Code`)
              return
            }
          })
          if (canUpload) {
            const agentData = results.data
            agentData.forEach(async (item: any) => {
              for (let key in item) {
                let upper = key.charAt(0).toLowerCase() + key.substr(1).split(' ').join('')
                if (upper !== key) {
                  item[upper] = item[key]
                  delete item[key]
                }
              }

              arrayHelpers.push({...item})
              setIsSubmit(true)
            })
            setValidationMsg('')
            setCsvValidationMsg('')
            setUplodingMessage(true)
            // setFileUploadErr(false)
          }
        }}
        onUploadRejected={async (file: any) => {
          const tempError: any = file[0]?.errors[0]
          if (tempError.code === 'file-invalid-type') {
            setCsvValidationMsg('')
            setFileUploadErr(true)
          }
        }}
        config={{header: true, delimiter: ',', skipEmptyLines: true}}
        onDragOver={(event: DragEvent) => {
          event.preventDefault()
        }}
        onDragLeave={(event: DragEvent) => {
          event.preventDefault()
        }}
      >
        {({getRootProps, acceptedFile, ProgressBar, getRemoveFileProps, Remove}: any) => (
          <>
            <div {...getRootProps()}>
              <>
                {acceptedFile ? (
                  <>
                    {uplodingMessage ? (
                      <div className='text-center'>
                        {!validationMsg && (
                          <label className='uploaded-label'>File uploaded successfully</label>
                        )}
                      </div>
                    ) : validationMsg ? (
                      <>
                        <p className='mt-1 text-danger'>Please upload valid data</p>
                        <Stack gap={2} className='align-items-center justify-content-center'>
                          <img
                            src={upload}
                            alt=''
                            width='40'
                            height='40'
                            className='svg-icon svg-icon-1'
                          />
                        </Stack>
                        <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                          Upload CSV
                        </span>
                      </>
                    ) : (
                      <>
                        <p className='mt-1 text-danger'>{csvValidationMsg}</p>
                        <Stack gap={2} className='align-items-center justify-content-center'>
                          <img
                            src={upload}
                            alt=''
                            width='40'
                            height='40'
                            className='svg-icon svg-icon-1'
                          />
                        </Stack>
                        <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                          Upload CSV
                        </span>
                        {fileUploadErr && (
                          <label className='uploaded-label err-label'>
                            Please upload the CSV file.
                          </label>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Stack gap={2} className='align-items-center justify-content-center'>
                      <img
                        src={upload}
                        alt=''
                        width='40'
                        height='40'
                        className='svg-icon svg-icon-1'
                      />
                      <span className='text-dark text-hover-primary fs-6'>
                        Drop files here or click to upload
                      </span>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Upload CSV
                      </span>
                      {!acceptedFile && fileUploadErr && (
                        <label className='uploaded-label err-label'>
                          Please upload the CSV file.
                        </label>
                      )}
                    </Stack>
                  </>
                )}
              </>
            </div>
          </>
        )}
      </CSVReader>
    </div>
  )
}
export default UploadAgentCSV
